"use strict";

module.exports = function (data, encoding) {
  if (typeof data === "number") {
    return Buffer.alloc(data);
  }

  return Buffer.from(data, encoding);
};

module.exports.test = function (b) {
  return Buffer.isBuffer(b);
};


//////////////////
// WEBPACK FOOTER
// ./~/pizzip/js/nodeBuffer.js
// module id = 247
// module chunks = 2